
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'

import { useState } from 'react';
import { Link as RouterLink, useLocation, useParams, useNavigate, useNavigation } from 'react-router-dom';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, Container, Fab, FormControl, Grid, InputLabel, List, ListItem, MenuItem, Select, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material'
import { KeyboardArrowLeftRounded, ExpandMore as ExpandMoreIcon } from '@mui/icons-material'
import { BaseURL } from '../../common/URLs';
import { render } from "react-dom";
import validator from "validator";
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { toast } from 'react-toastify';
import { emailValidation } from '../../common/commonValidations';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { HELPDESK_ROLES } from '../../common/constants';
import { loaderService } from '../../common/custom-loader/loader-service';
import { CloseIcon, SubmitIcon } from '../../common/icons';
import apiClient from '../../axios';

function AddEditSLAPage() {
    const auth = 'Bearer ' + getLocalStorageItem('id_token');
    const location = useLocation();
    const { id } = useParams();
    // const history = useNavigation();

    const [Flag, setFlag] = useState(null)


    const [isSubDisbaled, setSubDisabled] = useState(true);
    const [isSubCatSelected, setIsSubCatSelected] = useState(false);

    const [getCategory, setCategory] = useState(" ");
    const [getSubCat, setSubCatName] = useState(" ");
    const [respData, setRespData] = useState([]);
    const [resp1Data, setResp1Data] = useState([]);
    const navigate = useNavigate();
    const [sla1, setsla1] = useState('');
    const [duration1, setduration1] = useState('');
    const [sla2, setsla2] = useState('');
    const [duration2, setduration2] = useState('');
    const [sla3, setsla3] = useState('');
    const [duration3, setduration3] = useState('');
    const [getSubCatnew, setSubCatnewName] = useState(" ");
    const [priority, setpriority] = useState('');
    const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
    const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
    const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);


    // /////////////////  question //////////////////

    const [catsub, setCatsub] = useState([]);

    function handlenewSubcatChange(e) {
        setSubCatnewName(e.target.value);

    }


    function handleSubCategoryChange(e) {
        setSubCatName(e.target.value);
        setIsSubCatSelected(true);
        //  console.log(catsub, 'tttttttttttttttttttttttttttttttttttttttttt');
        const faqDetails1 = catsub.find(item => (item.grievanceCategory
            == getCategory && item.grievanceSubCategory
            == e.target.value))
        //  console.log(faqDetails1, getCategory, e.target.value, ' in the console deee');
        if (faqDetails1) {
            toast.error('Record is already present  you can only edit!');
            navigate('../manage-category');
        }


    }


    const [message1, setMessage1] = useState("");
    const [message2, setMessage2] = useState("");
    const [message3, setMessage3] = useState("");



    // ///////////////// answer //////////////////

    const handleChangedsla1 = (event) => {
        setsla1(event.target.value);
        var email = event.target.value;

        if (emailValidation(email)) {
            setMessage1("Thank you");
        } else {
            setMessage1("Please, enter valid Email!");
        }

    };
    const handleChangedsla2 = (event) => {
        setsla2(event.target.value);
        var email = event.target.value;

        if (emailValidation(email)) {
            setMessage2("Thank you");
        } else {
            setMessage2("Please, enter valid Email!");
        }

    };
    const handleChangedsla3 = (event) => {
        var email = event.target.value;

        setsla3(event.target.value);
        if (emailValidation(email)) {
            setMessage3("Thank you");
        } else {
            setMessage3("Please, enter valid Email!");
        }

    };
    const handleChangedduration1 = (event) => {
        setduration1(event.target.value);
        if (+event.target.value == 8) {
            setpriority('p1')
        }
        else if (+event.target.value == 16) {
            setpriority('p2')
        }
        else if (+event.target.value == 24) {
            setpriority('p3')
        }
        else if (+event.target.value == 32) {
            setpriority('p4')
        }
        else if (+event.target.value == 40) {
            setpriority('p5')
        }
        else if (+event.target.value == 48) {
            setpriority('p6')
        }
        else if (+event.target.value == 56) {
            setpriority('p7')
        }
        else if (+event.target.value == 64) {
            setpriority('p8')
        }
        else if (+event.target.value == 72) {
            setpriority('p9')
        }
        else {
            setpriority('p10')
        }
    };
    const handleChangedduration2 = (event) => {
        setduration2(event.target.value);
    };
    const handleChangedduration3 = (event) => {
        setduration3(event.target.value);
    };

    //Code for getting sub-category from category
    function handleCategoryChange(e) {
        setCategory(e.target.value);
        setSubDisabled(false);
        setIsSubCatSelected(false);
        // setFaq([]);
        //setCategory(getCategory) 
    }



    ///////////////////////////////////////////////


    useEffect(() => {
        //  managefaqsla()
        fetchCategory();

    }, [])
    useEffect(() => {
        managefaqsla()


    }, [id])


    // fetchCategoryAndSubcategory API
    const fetchCategory = () => {
        loaderService.showLoader();
        apiClient.post(
            BaseURL + "/grievanceandhelpdesk/v1/helpdesk/fetchCategoryAndSubcategory",
            {

            },
            {
                headers: {
                    "Authorization": auth,
                    "extFlag": localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? true : false
                },
            }
        ).then((response) => {
            // console.log("Success - ", response);
            setRespData(response.data);
            loaderService.hideLoader();
            // console.log(respData, "responseData");

        }).catch((error) => {
            console.log("Error - " + error);
            loaderService.hideLoader();
        })
    }

    //edity API
    const editrequest = () => {

        var regex = /[’/`~!#*$%+=.,^&(){}[\]|;:”<>?\\]/g;

        if (!emailValidation(sla1) || !emailValidation(sla2) || !emailValidation(sla3)) {
            toast.error('Please enter valid email')
        }
        else if (sla1.length > 100) {
            toast.error('please enter the sla1 within 100 words')
        }
        else if (sla2.length > 100) {
            toast.error('please enter the sla2 within 100 words')
        }
        else if (sla3.length > 100) {
            toast.error('please enter the sla3 within 100 words')
        }
        else {

            apiClient.post(
                BaseURL + "/grievanceandhelpdesk/v1/helpdesk/updateSlaMasterById",

                {

                    "id": id,
                    "grievanceCategory": getCategory,
                    "grievanceSubCategory": getSubCat == '' ? getSubCatnew : getSubCat,
                    //? means if
                    "isActive": "Y",
                    "updtdOn": new Date().toISOString(),
                    "slaDuration": +duration1,
                    "sla2Duration": +duration2,
                    "sla3Duration": +duration3,
                    "slaPriority": priority,
                    "sla1authority": sla1,
                    "sla2authority": sla2,
                    "sla3authority": sla3,
                    "extFlag": localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? 1 : 0

                },


                {
                    headers: {
                        "Authorization": auth
                    },
                }
            ).then((response) => {
                setRespData(response.data);
                response.data.status === "SUCCESS" ? toast.success(response.data.description) : toast.error(response.data.description)
                navigate('../manage-category')
            }).catch((error) => {
                console.log("Error - " + error);
            })
        }
    }

    const managefaqsla = () => {
        apiClient.post(
            BaseURL + "/grievanceandhelpdesk/v1/helpdesk/fetchAllSlaWithCategory",

            {


            },

            {
                headers: {
                    "Authorization": auth
                },
            }
        ).then((response) => {
            console.log("response ", response.data);
            //setmanagesladata(response.data);
            //setLoading(false)
            if (localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser) {
                let data = response.data.filter(item => item.extFlag === 1);
                setCatsub(data)
              }
              else {
                let data = response.data.filter(item => item.extFlag === 0);
                setCatsub(data)
              }
            // setCatsub(response.data)
            const faqDetails = response.data.find(item => item.id === id)
            console.log("Success -rrrrrrrrrrrrrrrrrr ", faqDetails);
            setCategory(faqDetails?.grievanceCategory)
            setSubCatName(faqDetails?.grievanceSubCategory)
            setsla1(faqDetails?.sla1authority)
            setsla2(faqDetails?.sla2authority)
            setsla3(faqDetails?.sla3authority)
            setduration1(faqDetails?.slaDuration)
            setduration2(faqDetails?.sla2Duration)
            setduration3(faqDetails?.sla3Duration)
            setpriority(faqDetails?.slaPriority)
            setFlag(faqDetails ? faqDetails : null)

            // console.log(respData, "responseData");

        }).catch((error) => {
            console.log("Error - " + error);
        })
    }

    //////////////////////////////////////////////////////////////////

    const adddata = () => {
        var regex = /[’/`~!#*$%+=,^&(){}[\]|;:”<>?\\]/g;

        if (!emailValidation(sla1) || !emailValidation(sla2) || !emailValidation(sla3)) {
            toast.error('Please enter valid email')
        }
        else if (sla1.length > 100) {
            toast.error('please enter the sla1 within 100 words')
        }
        else if (sla2.length > 100) {
            toast.error('please enter the sla2 within 100 words')
        }
        else if (sla3.length > 100) {
            toast.error('please enter the sla3 within 100 words')
        }
        else {
            apiClient.post(
                BaseURL + "/grievanceandhelpdesk/v1/helpdesk/addSlaMasterEntity",
                {
                    "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    "grievanceCategory": getCategory,
                    "grievanceSubCategory": getSubCat == '-1' ? getSubCatnew : getSubCat,
                    "isActive": "Y",
                    "crtdOn": new Date().toISOString(),
                    "slaDuration": +duration1,
                    "sla2Duration": +duration2,
                    "sla3Duration": +duration3,
                    "slaPriority": priority,
                    "sla1authority": sla1,
                    "sla2authority": sla2,
                    "sla3authority": sla3,
                    "extFlag": localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? 1 : 0
                },
                {
                    headers: {

                        "Authorization": auth
                    },
                }
            ).then((response) => {
                // console.log('eeeeeeeeee')
                //console.log(response.data.description);
                if (getSubCat == -1) {
                    apiClient.post(
                        BaseURL + "/grievanceandhelpdesk/v1/helpdesk/addingNewSubcategory",
                        {
                            "category": getCategory,
                            "subCategory": getSubCatnew,
                            "extFlag": localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? 1 : 0
                        },
                        {
                            headers: {

                                "Authorization": auth
                            },
                        }
                    ).then((response1) => {
                        const msg = "Please add FAQ for the new sub-category else ticket won't be created in this sub-category";
                        if (response1.data.status === "SUCCESS" && response.data.status === "SUCCESS") {
                            toast.success(response.data.description + msg)
                            navigate('../manage-category')
                        }
                        else if (response.data.status === "FAILURE") {
                            toast.error(response.data.description)
                        }
                        else toast.error(response1.data.description)
                    }).catch((error) => {
                        console.log(error);
                    });
                } else {
                    if (response.data.status === "SUCCESS") {
                        toast.success(response.data.description)
                        navigate('../manage-category')
                    }
                    else toast.error(response.data.description)
                }

                // setResp1Data(response.data)

                //setLoading(false)
            }).catch((error) => {
                console.log(error);
                toast.error('Please try again !')
            })
        }

    }
    const onConfirmSubmit = () => {
        handleConfirmLogModalClose();
        if (Flag !== null) {
            editrequest()
        }
        else {


            if (sla1 != '' || sla2 != '' || sla3 != '') {
                if (message1 == 'Thank you' && message2 == 'Thank you' && message3 == 'Thank you') {

                    adddata()
                }
                else {
                    toast.error('Please enter valid emails');
                }
            }

            else {
                toast.error('Please fill all details');

            }
        }
    }


    function submit() {
        handleConfirmLogModalOpen();
    }

    const [getFaq, setFaq] = useState([])
    const helpTopics = [...getFaq];



    const categoryList = localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser ? respData?.External_category : respData?.Helpdesk_category


    return (
        <>
            <Helmet>
                <title> Manage SLA edit/add| ABEPL </title>
            </Helmet>
            <Container maxWidth="xl">

                <Typography variant="h4" sx={{ mb: 2 }}>
                    <Fab component={RouterLink} to='../manage-category' size="small" aria-label="back" title='Back'>
                        <KeyboardArrowLeftRounded />
                    </Fab>  Manage SLA
                </Typography>
                <Card sx={{ paddingLeft: '4%' }}>
                    <Stack spacing={2} sx={{ pt: 1 }}>

                        <FormControl sx={{ width: '30%' }} >
                            <InputLabel id="select-category-label">Category</InputLabel>
                            <Select
                                labelId="select-category-label"
                                id="select-category"
                                label="category"

                                defaultValue={getCategory}

                                value={getCategory}
                                onChange={handleCategoryChange}
                            //  onClick={() => fetchCategory()}
                            >

                                <MenuItem value="">
                                    <em>Select</em>
                                </MenuItem>
                                {
                                    categoryList?.map(function (categoryList, i) {
                                        return <MenuItem key={categoryList} value={categoryList}>{categoryList}</MenuItem>
                                    })
                                }


                            </Select>
                        </FormControl>
                        <FormControl sx={{ width: '30%' }}>

                            <InputLabel id="select-subCategory-label">Sub-Category</InputLabel>
                            <Select
                                labelId="select-subCategory-label"
                                id="select-subCategory"
                                label="Sub-Category"
                                //   defaultValue={getSubCat}
                                value={getSubCat}
                                onChange={handleSubCategoryChange}
                            >
                                <MenuItem value="">
                                    <em>Select</em>
                                </MenuItem>
                                {respData && respData[`${getCategory}`]?.map(function (subcat, i) {
                                    return <MenuItem key={subcat} value={subcat}>
                                        {subcat}</MenuItem>
                                })}

                                {Flag ?
                                    <em></em> :
                                    <MenuItem value='-1'  >
                                        Add a new sub-category
                                    </MenuItem>
                                }
                            </Select>
                            {getSubCat == '-1' && 
                            <TextField sx={{ mt: 2}} id="outlined-multiline-flexible" multiline label='New sub-category' onChange={handlenewSubcatChange}
                            />}
                        </FormControl>
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ pt: 1 }}>
                        <TextField fullWidth
                            autoComplete="off"
                            //  id="outlined-multiline-static"
                            label="SLA1 Escalation Authority"
                            multiline
                            color="info"
                            rows={2}
                            onChange={handleChangedsla1}
                            value={sla1}
                            sx={{ paddingRight: '4%' }}
                        />


                        <FormControl sx={{ m: 1, minWidth: 350, paddingRight: '4%' }}>
                            <InputLabel >Duration1(Hrs)</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={duration1}
                                label="Duration1(Hrs)"
                                onChange={handleChangedduration1}
                            >
                                <MenuItem value={8}>8 Hrs</MenuItem>
                                <MenuItem value={16}>16 Hrs </MenuItem>
                                <MenuItem value={24}>24 Hrs</MenuItem>
                                <MenuItem value={32}>32 Hrs</MenuItem>
                                <MenuItem value={40}>40 Hrs</MenuItem>
                                <MenuItem value={48}>48 Hrs</MenuItem>
                                <MenuItem value={56}>56 Hrs</MenuItem>
                                <MenuItem value={64}>64 Hrs</MenuItem>
                                <MenuItem value={72}>72 Hrs</MenuItem>
                                <MenuItem value={80}>80 Hrs</MenuItem>

                            </Select>
                        </FormControl>
                    </Stack>

                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ pt: 1 }}>
                        <TextField fullWidth
                            autoComplete="off"
                            //  id="outlined-multiline-static"
                            label="SLA2 Escalation Authority"
                            multiline
                            color="info"
                            rows={2}
                            onChange={handleChangedsla2}
                            value={sla2}

                            sx={{ paddingRight: '4%' }}
                        />

                        <FormControl sx={{ m: 1, minWidth: 350, paddingRight: '4%' }}>
                            <InputLabel id="demo-simple-select-label">Duration2(Hrs)</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={duration2}
                                label="Duration2(Hrs)"
                                onChange={handleChangedduration2}
                            >
                                <MenuItem value={8}>8 Hrs</MenuItem>
                                <MenuItem value={16}>16 Hrs </MenuItem>
                                <MenuItem value={24}>24 Hrs</MenuItem>
                                <MenuItem value={32}>32 Hrs</MenuItem>
                                <MenuItem value={40}>40 Hrs</MenuItem>
                                <MenuItem value={48}>48 Hrs</MenuItem>
                                <MenuItem value={56}>56 Hrs</MenuItem>
                                <MenuItem value={64}>64 Hrs</MenuItem>
                                <MenuItem value={72}>72 Hrs</MenuItem>
                                <MenuItem value={80}>80 Hrs</MenuItem>

                            </Select>
                        </FormControl>
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ pt: 1 }}>
                        <TextField fullWidth
                            autoComplete="off"
                            //  id="outlined-multiline-static"
                            label="SLA3 Escalation Authority"
                            multiline
                            color="info"
                            rows={2}
                            onChange={handleChangedsla3}
                            value={sla3}

                            sx={{ paddingRight: '4%' }}
                        />

                        <FormControl sx={{ m: 1, minWidth: 350, paddingRight: '4%' }}>
                            <InputLabel id="demo-simple-select-label">Duration3(Hrs)</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={duration3}
                                label="Duration3(Hrs)"
                                onChange={handleChangedduration3}
                            >
                                <MenuItem value={8}>8 Hrs</MenuItem>
                                <MenuItem value={16}>16 Hrs </MenuItem>
                                <MenuItem value={24}>24 Hrs</MenuItem>
                                <MenuItem value={32}>32 Hrs</MenuItem>
                                <MenuItem value={40}>40 Hrs</MenuItem>
                                <MenuItem value={48}>48 Hrs</MenuItem>
                                <MenuItem value={56}>56 Hrs</MenuItem>
                                <MenuItem value={64}>64 Hrs</MenuItem>
                                <MenuItem value={72}>72 Hrs</MenuItem>
                                <MenuItem value={80}>80 Hrs</MenuItem>
                            </Select>
                        </FormControl>

                    </Stack>


                    &nbsp;
                    &nbsp;
                    <Box display='flex' alignItems="center" justifyContent="center">

                        <Button sx={{ minWidth: 120, mr: 2 }} variant="outlined" component={RouterLink} to='../manage-category' startIcon={<CloseIcon/>}>Cancel</Button>
                        &nbsp;
                        &nbsp;
                        <Button sx={{ minWidth: 120 }} variant="contained" onClick={() => { submit() }} endIcon={<SubmitIcon/>}>Submit</Button>

                    </Box>
                    &nbsp;
                    &nbsp;
                </Card>
                <ConfirmationPopover onOpen={logConfirmModalOpen} onConfirm={onConfirmSubmit} onClose={handleConfirmLogModalClose} action="Submit" />

            </Container>
        </>
    )
}

export default AddEditSLAPage